export default "__VITE_ASSET__CF8PY3Dm__"